import { getRemovedComponentDisplayName } from './removedComponentTypes';

export function parseType(type) {
  switch (type) {
    case 'api_export':
      return 'API Export';
    case 'api_request_and_response':
      return 'API Request and Response';
    case 'calculator':
      return 'Calculator';
    case 'conditional_logic':
      return 'Conditional Logic';
    case 'conditional_workflow':
      return 'Conditional Path';
    case 'create_database_record':
      return 'Create Database Record';
    case 'create_file':
      return 'Create File';
    case 'document_editor':
      return 'Document Editor';
    case 'email':
      return 'Email';
    case 'form':
      return 'Form';
    case 'dynamic_form':
      return 'Dynamic Form';
    case 'list_transform':
      return 'List Transform';
    case 'loop_through_list':
      return 'Split into Threads';
    case 'converge_threads':
      return 'Merge Threads';
    case 'query_database_record':
      return 'Query Database';
    case 'schedule_start':
      return 'Schedule Start';
    case 'slack':
      return 'Send Slack Message';
    case 'sequential_form':
      return 'Assign Task';
    case 'form_section':
      return 'Form Section';
    case 'dynamic_review_task':
      return 'Create Task';
    case 'form_step':
      return 'Form Step';
    case 'artifact':
      return 'Artifact';
    case 'trigger_from_a_workflow':
      return 'Trigger from a Workflow';
    case 'trigger_another_workflow':
      return 'Trigger another Workflow';
    case 'time_delay':
      return 'Time Delay';
    case 'update_database_record':
      return 'Update Database Record';
    case 'trigger_on_database_update':
      return 'Trigger on Database Update';
    case 'trigger_from_api_polling':
      return 'Trigger from API Polling';
    case 'await_external_event':
      return 'Await External Event';
    case 'bulk_assessment':
      return 'Upload Spreadsheet';
    case 'webhook':
      return 'Webhook Import';
    case 'trigger_via_email':
      return 'Trigger via Email';
    case 'ai_assistant':
      return 'AI Request';
    case 'ai_agent':
      return 'AI Agent';
    case 'gateway':
      return 'Gateway';
    case 'query_table_v2':
      return 'Query Table';
    case 'create_row_v2':
      return 'Create Row';
    case 'update_row_v2':
      return 'Update Row';
    case 'trigger_table_v2':
      return 'Table Trigger';
    case 'trigger_on_artifact':
      return 'Artifact Trigger';
    case 'custom_function':
      return 'Custom Function';
    case 'create_board_ticket':
      return 'Create Board Ticket';
    case 'get_board_ticket':
      return 'Get Board Ticket';
    case 'update_board_ticket':
      return 'Update Board Ticket';
    case 'trigger_on_board_ticket':
      return 'Trigger on Board Ticket';
    default:
      return getRemovedComponentDisplayName(type) || '';
  }
}
